<div class="license-card with-borders">
  <div class="license-card__header">
    <i class="icon mdi mdi-key"></i>
    <ng-container>
      <div class="license-card__header--title">{{license.featureTitle}}</div>
    </ng-container>
  </div>
  <div *ngIf="license.description" class="license-card__header">
    <ng-container>
      <div class="license-card__header--description">{{license.description}}</div>
    </ng-container>
  </div>
  <div class="license-card__content" *ngIf="license.showUsedCount">
    <ng-container>
      <div class="row">
        <div class="title">Total</div>
        <div class="text">{{license.count}}</div>
      </div>
      <div class="row">
        <div class="title">Used</div>
        <div class="text">{{license.used}}</div>
      </div>
    </ng-container>
  </div>
</div>
